function Configuration(): JSX.Element {
  return <h1>Configuration</h1>
}

export default Configuration
